import { toRem } from "../../../../helpers/theme";

const style = ({ theme }) => ({
    display: "inline-flex",
    verticalAlign: "middle",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    fontSize: toRem(34),
    transitionDuration: theme.transitions.button.default.duration,
    transitionTimingFunction: theme.transitions.button.default.timingFunction,
    transitionDelay: theme.transitions.button.default.delay,
    transitionProperty: "opacity",
    "&:focus": {
        opacity: 0.8,
    },
    "&:hover": {
        opacity: 0.8,
    },
    "&:active": {
        opacity: 0.8,
    },
});

export default style;
